<template>
    <div class="financial-details">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1>{{ financialDetailsPageHeading }}</h1>
                    <h2>{{ financialDetailsFinanceDetailsTitle }}</h2>


                    <div>
                        <span class="key">
                            Contract Term:
                        </span>
                        <span class="value">
                            <strong>{{ financials.contractTerm }} Months</strong>
                        </span>
                    </div>
                    <div>
                        <span class="key">
                            Mileage:
                        </span>
                        <span class="value">
                            <strong>{{ financials.mileage }}</strong>
                        </span>
                    </div>
                    <template v-if="isSalSacOrder">
                        <div v-if="quoteCosts">
                            <span class="key">
                                Gross Monthly Sacrifice:
                            </span>
                            <span class="value">
                                <strong>£{{ quoteCosts.gross_monthly_sacrifice }}</strong>
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            <span class="key">
                                Monthly Vehicle Payment:
                            </span>
                            <span class="value">
                                <strong>£{{ financials.monthlyVehiclePayment }}</strong>
                            </span>
                        </div>
                    </template>
<!--                    <div class="additional-financial-details">
                        <h2>{{ financialDetailsDeductionsTitle }}</h2>

                        <div>
                            <span class="key">
                               Scheme Insurances:
                            </span>
                            <span class="value">
                                <strong>£{{ financials.schemeInsurance }}</strong>
                            </span>
                        </div>

                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "financial-details",
    props: ['order', 'product', 'driverProfile', 'isSalSacOrder', 'quoteCosts'],
    computed: {
        financials() {
            return {
                contractTerm: this.order.quote.definition.plan.term,
                mileage: (this.order.quote.definition.plan.annualDistance).toLocaleString(),
                monthlyVehiclePayment: this.monthlyVehiclePayment,
                schemeInsurance: (
                    this.order.quote.taxCalculations
                    ? (Number(this.order.quote.taxCalculations?.calculationResults?.[0]?.employeeCostPrivateCar?.motoringAndFinance_InsuranceCost) / this.order.quote.definition.plan.term).toFixed(2)
                    : 'NOT SET'
                )
            }
        },
        monthlyVehiclePayment() {
            return Number(this.order.quote.details.pricing.totalIncVAT).toFixed(2);
        },
        financialDetailsPageHeading() {
            return this.product?.financial_details_page_heading ? this.product.financial_details_page_heading : '';
        },
        financialDetailsFinanceDetailsTitle() {
            return this.product?.financial_details_finance_details_title ? this.product.financial_details_finance_details_title : '';
        },
        financialDetailsDeductionsTitle() {
            return this.product?.financial_details_deductions_title ? this.product.financial_details_deductions_title : '';
        },
    }
}
</script>

<style scoped lang="scss">

.financial-details {
    padding: 4rem 0;
}

.additional-financial-details {
    margin: 2rem 0;
    padding-top: 2rem;
    border-top: 1px solid rgba(0, 0, 0, 0.1);

}

</style>
